<template>
    <div class="about">
        <Title :title="'Cota.80.86'"></Title>
        <div class="row middle-xs content">
            <div class="col-md-1 col-lg-3"></div>
            <div class="col-sm-6 col-md-5 col-lg-3 mobile-padded__evenly mobile-center" v-if="loaded">
                <div>
                    <p v-for="paragraph in entry.fields.body.content" :key="paragraph.content[0].value">
                        {{paragraph.content[0].value}}
                    </p>
                </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6" v-if="loaded">
                <div class="image-wrapper">
                    <img class="about-img" :src="entry.fields.image.fields.file.url" :alt="entry.fields.image.fields.description" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import contentHelper from "../../helpers/content.helper";
    import Title from "../generic/Title";

    export default {
        name: "About",
        components: {Title},
        data() {
            return {
                entry: null,
                loaded: false
            }
        },
        mounted() {
            contentHelper.client
                .getEntry("1QL7guS6Dxniz5S4GNT1TQ")
                .then(entry => {
                    this.entry = entry.toPlainObject();
                    this.loaded = true;
                })
                .catch(err => console.log(err));
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";

    .about {
        // margin-bottom: 3em;
        height: 100%;
        text-align: left;
    }

    .image-wrapper {
        margin-right: -7em;
        height: 100%;
        min-height: 30em;
    }

    .about-img {
        height: 100%;
        object-fit: cover;
        object-position: top;
        margin-bottom: -0.27em;
        //max-height: 30em;
    }

    @media only screen and (max-width: 767px) {
        .about-img {
            width: 100%;
        }
    }

    h1 {
    }

    p {
        font-family: "Merriweather", serif;
        line-height: 1.5em;
        color: $bgcolor-grey;
        font-size: 1em;
        font-weight: 400;
        font-style: italic;
        // padding-left: 1.5em;
    }

    .content {
        background-color: $primary;
    }
</style>
